var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 30,
    viewBox: "0 0 32 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_310_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2582 0L17.5273 10.1556L20.0807 4.17063L31.2582 0Z",
    fill: "#E17726"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.773813 0.0119629L11.9214 4.17134L14.3459 10.2348L0.773813 0.0119629ZM25.7324 21.5982L31.8013 21.7136L29.6803 28.9158L22.2749 26.8778L25.7324 21.5982ZM6.26731 21.5982L9.71194 26.8778L2.31906 28.916L0.210938 21.7136L6.26731 21.5982Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0164 8.69041L14.2644 16.6974L6.84302 16.3599L8.95402 13.1765L8.98077 13.1459L14.0164 8.69041ZM17.9068 8.60107L23.0193 13.1462L23.0458 13.1767L25.1568 16.3601L17.737 16.6974L17.9068 8.60107ZM9.92939 21.6215L13.9816 24.7775L9.27439 27.0492L9.92939 21.6215ZM22.0714 21.621L22.7128 27.0493L18.0186 24.7773L22.0714 21.621Z",
    fill: "#E27625"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1222 24.48L22.8856 26.7855L18.4547 28.8904L18.5007 27.4992L18.1222 24.48ZM13.8763 24.481L13.5127 27.4765L13.5426 28.8888L9.10132 26.7855L13.8763 24.481Z",
    fill: "#D5BFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5009 17.7424L13.7457 20.3573L9.50781 19.1164L12.5009 17.7424ZM19.4991 17.7427L22.5063 19.1164L18.2546 20.357L19.4991 17.7427Z",
    fill: "#233447"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2534 21.5947L9.56835 27.2223L5.89673 21.7177L10.2534 21.5947ZM21.7471 21.5948L26.1038 21.7177L22.4185 27.2226L21.7471 21.5948ZM25.2641 16.0416L22.0935 19.2716L19.6488 18.155L18.4785 20.6145L17.7112 16.3851L25.2641 16.0416ZM6.73448 16.0416L14.2888 16.3851L13.5215 20.6145L12.3509 18.1554L9.91923 19.2718L6.73448 16.0416Z",
    fill: "#CC6228"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.52075 15.3788L10.108 19.0174L10.2323 22.6095L6.52075 15.3788ZM25.4829 15.3723L21.7646 22.6159L21.9046 19.0174L25.4829 15.3723ZM14.1134 15.6005L14.2578 16.5088L14.6145 18.7718L14.3851 25.722L13.3008 20.1387L13.3004 20.081L14.1134 15.6005ZM17.8848 15.5878L18.6999 20.081L18.6995 20.1387L17.6124 25.736L17.5694 24.3359L17.3998 18.7305L17.8848 15.5878Z",
    fill: "#E27525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2234 18.8728L22.1021 21.9937L18.3178 24.9409L17.5528 24.4006L18.4103 19.9856L22.2234 18.8728ZM9.78955 18.8728L13.5894 19.9856L14.4469 24.4006L13.6819 24.9409L9.89755 21.9935L9.78955 18.8728Z",
    fill: "#F5841F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3772 26.0963L13.2187 28.3894L13.1982 27.4101L13.6033 27.0547H18.3951L18.8148 27.4089L18.7838 28.3874L23.5947 26.1021L21.2537 28.0357L18.4231 29.9791H13.5644L10.7357 28.0278L8.3772 26.0963Z",
    fill: "#C0AC9D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7755 24.1747L18.46 24.6581L18.8611 27.8573L18.2806 27.3673H13.7211L13.1516 27.8671L13.5396 24.6584L14.2244 24.1747H17.7755Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3517 0.281128L32 5.22368L30.9706 10.2212L31.7036 10.7863L30.7118 11.5428L31.4573 12.1183L30.4701 13.0168L31.0761 13.4555L29.4679 15.3329L22.8716 13.4131L22.8145 13.3825L18.0611 9.37444L30.3517 0.281128ZM1.64825 0.281128L13.939 9.37444L9.1855 13.3825L9.12838 13.4131L2.53212 15.3329L0.923875 13.4555L1.52937 13.0172L0.542875 12.1183L1.28688 11.5434L0.280125 10.7848L1.04075 10.2193L0 5.22393L1.64825 0.281128Z",
    fill: "#763E1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.549 12.9932L29.5381 15.0273L31.8087 22.0226H25.8182L21.6907 22.0746L24.6925 16.226L22.549 12.9932ZM9.45098 12.9932L7.30711 16.226L10.3092 22.0746L6.18361 22.0226H0.203857L2.46173 15.0274L9.45098 12.9932ZM20.423 4.13721L18.4681 9.41487L18.0532 16.5444L17.8945 18.7791L17.8819 24.4877H14.118L14.1057 18.7898L13.9465 16.5425L13.5315 9.41487L11.5769 4.13721H20.423Z",
    fill: "#F5841F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_310_77"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 29.9874,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.e1b1c213bf9eb4e5070bafdb40a975a2.svg";
export { ForwardRef as ReactComponent };